import { LAYOUTS } from '../keys'
const initialState = { layouts: [] }
export default function reducer(state = initialState, action) {
    switch (action.type) {
        case LAYOUTS: {
            return { ...state, layouts: action.payload }
        }
        default:
            return { ...state }
    }

}